import React from 'react';
import { useDMUnlockManager } from '../../hooks/useDMUnlockPolling';

const DMUnlockManager: React.FC = () => {
  useDMUnlockManager();
  return null;
};

export default DMUnlockManager;
